/**
 * Destino do follow-up: etapas, disparo e horário comercial.
 */
import React from 'react';
import type { FollowUpDelayUnit } from '../types';
import FollowUpSendToFields from './FollowUpSendToFields';
import FollowUpTriggerFields from './FollowUpTriggerFields';
import FollowUpBusinessHoursFields from './FollowUpBusinessHoursFields';

interface FollowUpDestinationFieldsProps {
    fieldId: string;
    delayValue: number;
    delayUnit: FollowUpDelayUnit;
    onDelayValueChange: (value: number) => void;
    onDelayUnitChange: (unit: FollowUpDelayUnit) => void;
    stageIds: string[];
    onAddStage: (stageId: string) => void;
    onRemoveStage: (stageId: string) => void;
    timezone: string;
    onTimezoneChange: (timezone: string) => void;
    businessHoursStart: string;
    onBusinessHoursStartChange: (value: string) => void;
    businessHoursEnd: string;
    onBusinessHoursEndChange: (value: string) => void;
    businessHoursWeekdaysOnly: boolean;
    onBusinessHoursWeekdaysOnlyChange: (value: boolean) => void;
}

export default function FollowUpDestinationFields(props: FollowUpDestinationFieldsProps) {
    return (
        <div className="flex flex-col gap-s5">
            <FollowUpSendToFields
                fieldId={props.fieldId}
                stageIds={props.stageIds}
                onAddStage={props.onAddStage}
                onRemoveStage={props.onRemoveStage}
            />
            <FollowUpTriggerFields
                fieldId={props.fieldId}
                delayValue={props.delayValue}
                delayUnit={props.delayUnit}
                onDelayValueChange={props.onDelayValueChange}
                onDelayUnitChange={props.onDelayUnitChange}
            />
            <FollowUpBusinessHoursFields
                fieldId={props.fieldId}
                timezone={props.timezone}
                onTimezoneChange={props.onTimezoneChange}
                businessHoursStart={props.businessHoursStart}
                onBusinessHoursStartChange={props.onBusinessHoursStartChange}
                businessHoursEnd={props.businessHoursEnd}
                onBusinessHoursEndChange={props.onBusinessHoursEndChange}
                businessHoursWeekdaysOnly={props.businessHoursWeekdaysOnly}
                onBusinessHoursWeekdaysOnlyChange={props.onBusinessHoursWeekdaysOnlyChange}
            />
        </div>
    );
}
